export class TitleRequest {
    id: number;
    content_id: string;
    account_id: number;
    date_requested: Date;
}



// WEBPACK FOOTER //
// ./src/app/tms/model/titleRequest.ts